import { render } from "./ClusterPage.vue?vue&type=template&id=3ef59247"
import script from "./ClusterPage.vue?vue&type=script&lang=js"
export * from "./ClusterPage.vue?vue&type=script&lang=js"
script.render = render

export default script